import React, { Fragment } from 'react'
import styled, { css } from 'react-emotion'
import { compose } from 'recompose'
import { Query } from 'react-apollo'
import { Container, Row, color, mediaDn, spacer } from 'stylist'
import VIDEOS_QUERY from './videos.query'
import VideoUploader from './videos/components/VideoUploader'
import VideoUploaderV2 from './videos/components/VideoUploaderV2'
import VideoUploaderV3 from './videos/components/VideoUploaderV3'
import PageLoader from 'components/PageLoader'
import VideosTable from './videos/components/VideosTable'
import Feature from 'components/Feature'
import { Consumer as UploadsConsumer } from 'components/UploadsContext'
import withFeature from 'components/withFeature'
import VideoUploadProgressTile from './videos/components/VideoUploadProgressTile'
import DashboardSession from './videos/components/DashboardSession'
import VideoTile from './videos/components/VideoTile'
import TileContainer from './videos/components/TileContainer'
import { connectionNodes } from 'utils/relay'
import { filter } from 'utils/fp'

const filterArchivedVideos = compose(
  filter(({ archived, ...rest }) => !archived),
  connectionNodes
)

const HeadingContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${spacer(3)};
`

const RowWithSpacing = withFeature(styled(Row)`
  padding: ${spacer(5)} 0;

  ${({ hasFeature, theme }) =>
    hasFeature('homepage_redesign') &&
    css`
      &:nth-child(even) {
        background-color: ${color('paleGrey', { theme })};
      }
    `};
`)

const VideosGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: ${spacer(5)};

  ${mediaDn('md')} {
    grid-template-columns: 1fr 1fr;
    grid-gap: ${spacer(4)};
  }

  ${mediaDn('sm')} {
    grid-template-columns: 1fr;
  }
`

const RedesignedRouteVideo = ({ match: { path, url }, history }) => (
  <Fragment>
    <Feature
      name="dashboard_session"
      render={() => (
        <RowWithSpacing>
          <DashboardSession />
        </RowWithSpacing>
      )}
    />
    <RowWithSpacing>
      <Container>
        <HeadingContainer>
          <h5>Videos</h5>
        </HeadingContainer>
        <Query query={VIDEOS_QUERY}>
          {({ loading, data }) =>
            loading ? (
              <PageLoader />
            ) : (
              <VideosGrid>
                <TileContainer isUploader>
                  <VideoUploaderV3 />
                </TileContainer>

                <UploadsConsumer>
                  {({ abortUpload, removeUpload, uploads }) =>
                    uploads.map(upload => (
                      <TileContainer processing key={upload.url}>
                        <VideoUploadProgressTile
                          {...upload}
                          abortUpload={abortUpload}
                          removeUpload={removeUpload}
                        />
                      </TileContainer>
                    ))
                  }
                </UploadsConsumer>
                {filterArchivedVideos(data.viewer.videos).map(video => (
                  <VideoTile key={video.id} {...video} />
                ))}
              </VideosGrid>
            )
          }
        </Query>
      </Container>
    </RowWithSpacing>
  </Fragment>
)

const OldRouteVideos = ({ match: { path, url }, history }) => (
  <Fragment>
    <RowWithSpacing>
      <Container>
        <Feature
          name="new_uploader"
          fallback={() => <VideoUploader />}
          render={() => <VideoUploaderV2 />}
        />
      </Container>
    </RowWithSpacing>
    <RowWithSpacing>
      <Container>
        <Query query={VIDEOS_QUERY}>
          {({ loading, data }) =>
            loading ? (
              <PageLoader />
            ) : (
              <Fragment>
                <HeadingContainer>
                  <h5>Highlight Reel Generator</h5>
                </HeadingContainer>
                {data.viewer.videos.edges.length ? (
                  <VideosTable videos={data.viewer.videos} path={path} />
                ) : (
                  <p>
                    You have no highlight reels! Upload a video to get started.
                  </p>
                )}
              </Fragment>
            )
          }
        </Query>
      </Container>
    </RowWithSpacing>
  </Fragment>
)

const RouteVideos = props => (
  <Feature
    name="homepage_redesign"
    fallback={() => <OldRouteVideos {...props} />}
    render={() => <RedesignedRouteVideo {...props} />}
  />
)

export default RouteVideos



// WEBPACK FOOTER //
// ./src/routes/videos.js